import { render, staticRenderFns } from "./HotListCompanies.vue?vue&type=template&id=c383c1e4&scoped=true"
import script from "./HotListCompanies.vue?vue&type=script&lang=js"
export * from "./HotListCompanies.vue?vue&type=script&lang=js"
import style0 from "./HotListCompanies.vue?vue&type=style&index=0&id=c383c1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c383c1e4",
  null
  
)

export default component.exports